import { render, staticRenderFns } from "./RubricTile.vue?vue&type=template&id=689cb0ec"
import script from "./RubricTile.vue?vue&type=script&lang=js"
export * from "./RubricTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports